import * as S from './style';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Para, Head_3 } from '../Typography';

const Service = ({ icon, title, description, className }) => {
  return (
    <S.Container>
      <S.ContantService className={className}>
        <FontAwesomeIcon icon={icon} size="3x" />
        <Head_3>{title}</Head_3>
        <Para>{description}</Para>
      </S.ContantService>
    </S.Container>
  );
};

export default Service;
